import React, { useEffect, useState, useMemo } from 'react';
import { Container, Form, Row, Col } from 'reactstrap';
import BreadCrumb from '../Common/BreadCrumb';
import { ToastContainer } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../Utils/Loader';
import { customerIdData } from '../Customers/constants/constantFunctionsView';
import { getOrderById } from '../../slices/orderManagement/getorder/thunk';
import { fetchAllOffers } from '../../slices/offer/thunk';
import { getAllService } from '../../slices/services/thunk';
import { createOrderPayload } from './constants/OrderPayload';
import { useStateArray } from './constants/StateArray';
import TableColumns from './constants/OrderDetailColoumn';
import { PAGE_TITLES } from '../Common/constants';
import { CancelOrder } from './CancelOrder';
import { Formik } from 'formik';
import { initialCancelValues } from './constants/initialValues';
import { validationForCancelOrder } from './constants/Formdata';
import CommonModal from '../Utils/CommonModal';
import { closeModal, toggleModal } from './constants/HandleReasonChange';
import { performCancelApiRequest, performPatchCancelRequest } from './constants/CancelOrderPayloads';
import { viewOrCancelTableData } from './constants/ViewOrCancelTableData';
import { OrderDetailsInViewCancel } from './OrderDetailsInViewCancel';
import { CustomerDetailsInViewCancel } from './CustomerDetailsInViewCancel';
import { TableDataForViewCancel } from './TableDataForViewCancel';
import { CancelOrPlaceButtons } from './CancelOrPlaceButtons';
import { createPreviewPayload } from './constants/previewOrderPayload';
import { addOrderToPreview, addQuantity } from '../../slices/orderManagement/previewOrder/reducer';
import { getPreview } from '../../slices/orderManagement/previewOrder/thunk';

function OrderDetails() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const OrderID = state?.orderId || '';
    const [quantities, setQuantities] = useState({});
    const { serviceName, offerName, offerCode, termValidity, validityFrom, validityTo, formData, totalChargeAmount, unitPrice, subTotal, CustomerId, CustomerName } = state || {};
    const { resourceOverrides } = state || {};
    const [status, setStatus] = useState("-");
    const [orderID, setOrderID] = useState('')
    const [displayButton, setDisplayButton] = useState(false)
    const [loading, setLoading] = useState(false)
    const currentDate = moment();
    const [showSaveButton, setShowSaveButton] = useState(false);
    const [createOrderButton, setCreateOrderButton] = useState(false);
    const [taxAmount, setTaxAmount] = useState(0)
    const [totalAmountWithTax, setTotalAmountWithTax] = useState(0)
    const [SGST, setSGST] = useState(0)
    const [CGST, setCGST] = useState(0)
    const [taxDetails, setTaxDetails] = useState({});
    const [reason, setReason] = useState('')
    const [modal, setModal] = useState(false)
    const isView = location.pathname.includes('view-order')
    const isCancel = location.pathname.includes('cancel-order')
    const stateArray = useMemo(() => useStateArray(formData, serviceName, offerName, offerCode, termValidity, validityFrom, validityTo, status, totalChargeAmount, subTotal, unitPrice, CustomerId, CustomerName, orderID, resourceOverrides), [formData, serviceName, offerName, offerCode, termValidity, validityFrom, validityTo, status, totalChargeAmount, subTotal, unitPrice, CustomerId, CustomerName, orderID]);
    const handleQuantityChange = (subscriptionID, newQuantity) => {
        dispatch({ type: 'QUANTITY_CHANGE', payload: { subscriptionID: subscriptionID, quantity: newQuantity } });
        dispatch(addQuantity({ subscriptionID: subscriptionID, quantity: newQuantity }))
        setQuantities(prev => ({
            ...prev,
            [subscriptionID]: newQuantity,
        }));
    };

    const operatorConfiguration = useSelector((state) => state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration)
    const prefix = operatorConfiguration?.configurations?.Prefixes?.value?.OrderPrefix?.value
    const sequence = operatorConfiguration?.configurations?.SequenceHandling?.value?.OrderSequence?.value
    const id = prefix && prefix + 'X'.repeat(sequence?.length)


    useEffect(() => {
        dispatch({ type: 'ADD_ORDER', payload: stateArray });
    }, [dispatch, stateArray]);

    const orderData = useSelector((state) => state.SelectOrder);
    const allOrderData = orderData?.orders || []
    // Add quantity to order data
    const updatedOrderData = allOrderData.map(order => ({
        ...order,
        quantity: order?.quantity || quantities[order.subscriptionID] || 1,  // Default to 1 if quantity is not set
    }));
    const isAcknowledged = status === 'Acknowledged';
    const { columns, viewColumns } = TableColumns(status, handleQuantityChange, quantities, isAcknowledged, id);
    // Log the updated data with quantities
    updatedOrderData.forEach(updatedOrderData => {
        updatedOrderData.subTotal = updatedOrderData.unitPrice * updatedOrderData.quantity;
    });

    const totalAmountFromOrders = updatedOrderData.reduce((acc, order) => acc + order.subTotal, 0);
    const authorName = localStorage.getItem("userId")

    const payload = createOrderPayload(updatedOrderData, CustomerId, CustomerName, authorName, resourceOverrides);
    const deviceId = customerIdData()

    useEffect(() => {
        setShowSaveButton(status === "Acknowledged");
    }, [status, updatedOrderData]);

    useEffect(() => {
        if (isView || isCancel) {
            dispatch(getOrderById(deviceId, setLoading))
            dispatch(fetchAllOffers(setLoading))
            dispatch(getAllService(setLoading))
        }
    }, [])

    const orderDataById = useSelector((state) => state.GetOrderById.getOrder)
    const allOfferData = useSelector((state) => state.Offer.offer)
    const serviceData = useSelector((state) => state.Services.services)
    const cancelOrderData = useSelector((state) => state.CancelOrder.cancelOrder)

    const orders = useSelector(state => state.previewOrder.previewOrder);
    useEffect(() => {
        let payload;
        if (!isView && !isCancel) {
            if (orders.length === 0) {
                payload = createPreviewPayload(orders, CustomerId);
            }
            payload = createPreviewPayload(orders, CustomerId);
            dispatch(getPreview(payload, setTaxDetails, setLoading))
        }
    }, [orders])

    const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;

    const customerListTitle = isEIPEnabled
        ? PAGE_TITLES.CUSTOMER_LIST_EIP
        : PAGE_TITLES.CUSTOMER_LIST;

    const tableData = (isView || isCancel) && viewOrCancelTableData(allOfferData, orderDataById, serviceData)
    let { subTotalValue, taxValue, totalPrice, offerDataOfOrder, CountryGST, StateGST } = tableData
    return (
        <React.Fragment>
            <div id='csms' className='page-content bg-white'>
                <Formik initialValues={initialCancelValues} validationSchema={validationForCancelOrder(reason)} onSubmit={(values) => {
                    performCancelApiRequest(orderDataById.id, values, dispatch)
                    toggleModal(setModal)
                }}>
                    {({ values, handleChange, handleBlur, errors, touched, setFieldTouched, setFieldValue, handleSubmit }) => (
                        <Form className="needs-validation" onSubmit={handleSubmit}>
                            <Container fluid>
                                <BreadCrumb title={isView ? PAGE_TITLES.VIEW_ORDER : isCancel ? PAGE_TITLES.CANCEL_ORDER : PAGE_TITLES.CUSTOMER_SUBSCRIBE} pageTitle={isView ? PAGE_TITLES.CUSTOMER_ORDER : customerListTitle} />
                                <ToastContainer position='top-center' />
                                <Row>
                                    {loading && <Loader data-testid="loader" />}
                                    <Col lg={3} md={4} sm={12}>
                                        <div className="border border-1 rounded-1 p-3 h-100">
                                             <CustomerDetailsInViewCancel isCancel={isCancel} isView={isView} orderDataById={orderDataById} CustomerId={CustomerId} CustomerName={CustomerName} />
                                             <hr />
                                            <OrderDetailsInViewCancel isCancel={isCancel} isView={isView} orderDataById={orderDataById} orderID={orderID} status={status} currentDate={currentDate} />


                                        </div>

                                    </Col>
                                    <Col lg={9} md={8} sm={12}>
                                    { isCancel && <div className="border border-1 rounded-1 p-3 mb-3">
                                            <CancelOrder values={values} handleChange={handleChange} handleBlur={handleBlur} errors={errors} touched={touched} setFieldTouched={setFieldTouched} setFieldValue={setFieldValue} setReason={setReason} />
                                        </div> }
                                    <div className="border border-1 rounded-1 p-3 mb-3">
                                        <TableDataForViewCancel setOrderID={setOrderID} setTotalAmountWithTax={setTotalAmountWithTax} setTaxAmount={setTaxAmount} isCancel={isCancel} isView={isView} showSaveButton={showSaveButton} OrderID={OrderID} orderID={orderID} allOrderData={updatedOrderData} dispatch={dispatch} setLoading={setLoading} navigate={navigate} setDisplayButton={setDisplayButton} state={(state) => setStatus(state)} setCreateOrderButton={setCreateOrderButton} CustomerId={CustomerId} stateArray={stateArray} viewColumns={viewColumns} columns={columns} offerDataOfOrder={offerDataOfOrder} />
                                    </div>
                                    

                                    <CancelOrPlaceButtons setTotalAmountWithTax={setTotalAmountWithTax} totalAmountWithTax={totalAmountWithTax} setTaxAmount={setTaxAmount} taxAmount={taxAmount} status={status} isView={isView} isCancel={isCancel} subTotalValue={subTotalValue} totalAmountFromOrders={totalAmountFromOrders} taxValue={taxValue} totalPrice={totalPrice} displayButton={displayButton} OrderID={OrderID} orderID={orderID} createOrderButton={createOrderButton} navigate={navigate} setCreateOrderButton={setCreateOrderButton} setLoading={setLoading} createOrCancel={"Create"} setDisplayButton={setDisplayButton} state={(state) => setStatus(state)} setOrderID={setOrderID} payload={payload} dispatch={dispatch} CGST={CGST} setCGST={setCGST} setSGST={setSGST} SGST={SGST} CountryGST={CountryGST} StateGST={StateGST} taxDetails={taxDetails} />
                                    </Col>

                                    
                                </Row>
                            </Container>
                        </Form>
                    )}
                </Formik>
            </div>
            <CommonModal open={modal} toggle={() => closeModal(setModal, modal)} buttonText={"Yes, Cancel It"} messageForPopUp={`Are you sure you want to Cancel this Order "${orderDataById.id}"?`} modalAction={() => { performPatchCancelRequest(setLoading, cancelOrderData.id, navigate, dispatch) }} />
        </React.Fragment>
    );
}
export default OrderDetails;